<div class="upcoming-bookings-card">
  <div class="card-header">
    <div class="header-left">
      <app-icon [type]="IconType.CALENDAR" [size]="20"></app-icon>
      <h3 class="card-title">Kommende Termine</h3>
    </div>
    @if (activities.length > 0) {
      <button class="btn btn-tertiary" (click)="onViewAll()">
        Alle Buchungen anzeigen
        <app-icon [type]="IconType.CHEVRON_RIGHT" [size]="16"></app-icon>
      </button>
    }
  </div>

  <div class="card-content">
    @if (loading) {
      <div class="loading-state">
        @for (i of [1, 2, 3]; track i) {
          <div class="skeleton-item">
            <div class="skeleton skeleton-date"></div>
            <div class="skeleton skeleton-details"></div>
          </div>
        }
      </div>
    } @else if (activities.length === 0) {
      <div class="empty-state">
        <app-icon [type]="IconType.CALENDAR" [size]="40"></app-icon>
        <p class="empty-title">Keine kommenden Termine</p>
        <p class="empty-subtitle">Buche jetzt deinen nächsten Platz!</p>
        <button class="btn btn-primary" (click)="onBookNow()">
          Jetzt buchen
        </button>
      </div>
    } @else {
      <div class="bookings-list">
        @for (activity of activities; track activity.id) {
          <div class="booking-item">
            <div class="booking-date" [ngClass]="'date-' + activity.type">
              <span class="date-label">{{ formatDate(activity.startTime) }}</span>
              <span class="time-label">{{ formatTime(activity.startTime) }}</span>
            </div>
            <div class="booking-details">
              <div class="title-row">
                <span class="court-name">{{ activity.title }}</span>
                <span [class]="getActivityTypeClass(activity.type)">
                  <app-icon [type]="getActivityTypeIcon(activity.type)" [size]="10"></app-icon>
                  {{ getActivityTypeLabel(activity.type) }}
                </span>
              </div>
              <span class="booking-meta">
                <app-icon [type]="IconType.CLOCK" [size]="12"></app-icon>
                {{ formatDuration(activity.startTime, activity.endTime) }}
                @if (activity.subtitle) {
                  <span class="category-dot"></span>
                  {{ activity.subtitle }}
                }
              </span>
            </div>
            <div class="booking-status">
              <!-- Bookings use 'confirmed', course sessions use 'scheduled' -->
              @if (activity.status === 'confirmed' || activity.status === 'scheduled') {
                <span class="status-badge confirmed">
                  <app-icon [type]="IconType.CHECK" [size]="12"></app-icon>
                  Bestätigt
                </span>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
